export const MENSAGEM_ERRO_DESCONHECIDO_APLICACAO = 'A aplicação lançou um erro de um tipo desconhecido: ';
